import { AccordionIdentityCard } from 'shell/view-models/accordion-identity-card';
import { IdentityCard } from 'shell/models/person/identity-card';
import { Municipality, Consulate } from 'shell/models/person/shared';

export const transformIdentityCard = (
  values: AccordionIdentityCard | undefined
): IdentityCard | undefined => {
  const comuneRilascio: Municipality | undefined =
    values?.municipality?.id || values?.province
      ? {
          nomeComune: values?.municipality?.description || undefined,
          codiceIstat: values?.municipality?.id || undefined,
          siglaProvinciaIstat: values?.municipality?.province || values?.province || undefined,
          descrizioneLocalita: values?.location || undefined,
        }
      : undefined;

  const consolatoRilascio: Consulate | undefined = values?.consulateCode
    ? {
        codiceConsolato: values?.consulateCode || undefined,
      }
    : undefined;

  const result: IdentityCard | undefined = values
    ? {
        numero: values?.number || undefined,
        dataRilascio: values?.releaseDate?.toFormat('yyyy-MM-dd') || undefined,
        cartaceaElettronica: values?.type === '3' ? '1' : values?.type || undefined,
        interdizioneEspatrio: values?.expatriationBan ? 'S' : 'N',
        comuneRilascio: comuneRilascio || undefined,
        consolatoRilascio: consolatoRilascio || undefined,
        dataScadenza: values.expirationDate?.toFormat('yyyy-MM-dd') || undefined,
        dataAnnullamento: values?.cancellationDate?.toFormat('yyyy-MM-dd') || undefined,
      }
    : undefined;

  return result;
};
